import axios from "@/api/axiosInstance";
import type { GetSubscriptionResponse } from "./types";

/**
 * Fetch a subscription by its local (company-scoped) uuid. The BE
 * looks up the local Subscription row, then relays CARA's fresh
 * billing state. Returns 404 if the uuid doesn't belong to the
 * caller's company.
 */
export const getSubscription = async (
  subscriptionUuid: string,
): Promise<GetSubscriptionResponse> => {
  const response = await axios.get<GetSubscriptionResponse>(
    `/api/private/subscriptions/${encodeURIComponent(subscriptionUuid)}`,
  );
  return response.data;
};
